export default __webpack_public_path__ + "static/media/delete-account.4c03bcf5.png";